module.exports = __webpack_public_path__ + "static/media/1026166.5ffe62d5.jpg";